function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, computed, watch, getCurrentInstance } from "vue";
import { FileStatus, UploadStatus } from "@pt/store/assets/uploader.type";
import useUploaderModule from "@pt/views/pt-entry/creative-assets/media/uploader-module";
export default defineComponent({
    components: {},
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var ref = useUploaderModule(), isUploadingStatus = ref.isUploadingStatus, fileList = ref.fileList, selectedFileList = ref.selectedFileList, totalSize = ref.totalSize, usedSize = ref.usedSize, isUploadEndStatus = ref.isUploadEndStatus;
        watch(function() {
            return fileList.value;
        }, function(val) {
            if (val.length && !store.state.assets.uploader.dialogVisible) {
                store.commit("assets/uploader/setDialogVisible", true);
            }
        });
        var showFooter = computed(function() {
            return fileList.value.length && !isUploadingStatus.value;
        });
        var loading = computed(function() {
            return false;
        });
        var submitButton = computed(function() {
            return {
                loading: loading.value,
                disabled: !selectedFileList.value.length || usedSize.value >= totalSize.value,
                type: "primary"
            };
        });
        var innerDialog = computed(function() {
            return {
                closeOnPressEscape: false,
                width: "700px",
                // appendToBody: true,
                beforeClose: function(done) {
                    if (fileList.value.length === 0) {
                        return done();
                    }
                    return false;
                },
                modal: !(isUploadingStatus.value || isUploadEndStatus.value)
            };
        });
        var isShowOnRightTop = computed(function() {
            return isUploadingStatus.value || isUploadEndStatus.value;
        });
        var handleCancel = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            store.dispatch("assets/uploader/removeAllFile");
                            store.commit("assets/uploader/setDialogVisible", false);
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleCancel() {
                return _ref.apply(this, arguments);
            };
        }();
        var submitDialog = function() {
            var selectedIds = selectedFileList.value.map(function(file) {
                return Number(file.id);
            });
            var removeFiles = [];
            fileList.value.forEach(function(file) {
                if (selectedIds.includes(file.id)) {
                    file.resume();
                    store.commit("assets/uploader/updateFileExtraProp", {
                        id: file.id,
                        data: {
                            status: FileStatus.uploading
                        }
                    });
                } else {
                    console.log("\u5220\u9664\u6587\u4EF6", file.id);
                    removeFiles.push(file);
                }
            });
            // 因为删除 file 的时候会直接 remove fileList的元素，如果用 forEach 会有漏删
            removeFiles.forEach(function(file) {
                store.commit("assets/uploader/removeFile", file);
                file.cancel();
            });
            store.commit("assets/uploader/setUploadStatus", UploadStatus.uploading);
            // 为了复用弹框，因此点击上传需要隐藏 v-modal
            if (document.querySelector(".v-modal")) {
                document.querySelector(".v-modal").remove();
                document.body.classList.remove("el-popup-parent--hidden");
            }
        };
        return {
            dialogVisible: computed({
                get: function() {
                    return store.state.assets.uploader.dialogVisible;
                },
                set: function(val) {
                    store.commit("assets/uploader/setDialogVisible", Boolean(val));
                }
            }),
            innerDialog: innerDialog,
            loading: loading,
            handleCancel: handleCancel,
            submitDialog: submitDialog,
            submitButton: submitButton,
            fileList: fileList,
            showFooter: showFooter,
            isShowOnRightTop: isShowOnRightTop
        };
    }
});
